import explanationFormHelper from '@/commons/workbook/explanationFormHelper';
import expAPI from '@/apis/di/dictionaryPresentAPI';
import GC from '@grapecity/spread-sheets';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import i18nWorkbook from '@/i18ns/i18nWorkbook';
import commonFunction from '../commonFunction';
import { Workbook } from 'exceljs';

/**
 * Dữ liệu font size
 */
const FontSizes = [
  {
    value: 8,
    display: 8,
  },
  {
    value: 9,
    display: 9,
  },
  {
    value: 10,
    display: 10,
  },
  {
    value: 11,
    display: 11,
  },
  {
    value: 12,
    display: 12,
  },
  {
    value: 13,
    display: 13,
  },
  {
    value: 14,
    display: 14,
  },
  {
    value: 15,
    display: 15,
  },
  {
    value: 16,
    display: 16,
  },
  {
    value: 18,
    display: 18,
  },
  {
    value: 20,
    display: 20,
  },
  {
    value: 24,
    display: 24,
  },
  {
    value: 26,
    display: 26,
  },
  {
    value: 28,
    display: 28,
  },
  {
    value: 36,
    display: 36,
  },
  {
    value: 48,
    display: 48,
  },
  {
    value: 72,
    display: 72,
  },
];

const FormatCell = [
  { display: 'General', value: 'General' },
  { display: 'Number', value: '#,##0' },
  { display: 'Currency', value: '$#,##0.00' },
  { display: 'Accounting', value: '$ #,##0.00;$ (#,##0.00);$ "-"??;@' },
  { display: 'Short Date', value: 'dd/mm/yyyy' },
  { display: 'Long Date', value: 'dddd, mmmm dd, yyyy' },
  { display: 'Time', value: 'h:mm:ss AM/PM' },
  { display: 'Percentage', value: '0.00%' },
  { display: 'Scientific', value: '0.00E+00' },
  { display: 'Constant', value: '#,##0.000' },
  { display: 'Text', value: '@' },

  { display: 'One', value: '#,##0.00' },
  { display: 'Thousand', value: '#,##0.000,' },
  { display: 'Million', value: '#,##0.000,,' },
  { display: 'Billion', value: '#,##0.000,,,' },
];

const FontFamilies = [
  {
    value: 'Arial',
    display: 'Arial',
  },
  {
    value: 'Arial Narrow',
    display: 'Arial Narrow',
  },
  {
    value: 'Helvetica',
    display: 'Helvetica',
  },
  {
    value: 'Times New Roman',
    display: 'Times New Roman',
  },
  {
    value: 'Times',
    display: 'Times',
  },
  {
    value: 'Courier New',
    display: 'Courier New',
  },
  {
    value: 'Verdana',
    display: 'Verdana',
  },
  {
    value: 'Georgia',
    display: 'Georgia',
  },
  {
    value: 'Palatino',
    display: 'Palatino',
  },
  {
    value: 'Garamond',
    display: 'Garamond',
  },
  {
    value: 'Bookman',
    display: 'Bookman',
  },
  {
    value: 'Comic Sans MS',
    display: 'Comic Sans MS',
  },
  {
    value: 'Trebuchet MS',
    display: 'Trebuchet MS',
  },
  {
    value: 'Impact',
    display: 'Impact',
  },
];

const FormatterOptions = [
  {
    value: 'General',
    display: 'General',
  },
  {
    value: '###,###',
    display: 'Currency',
  },
  {
    value: 'dd-mm-yyyy',
    display: 'Datetime',
  },
];

const menuItemsBorder = [
  {
    icon: 'ic-excel toolbar-border-none',
    text: 'Không viền',
    option: i18nEnum.BorderOptions.None,
  },
  {
    icon: 'ic-excel toolbar-border-all',
    text: 'Viền toàn bộ',
    option: i18nEnum.BorderOptions.All,
  },
  {
    icon: 'ic-excel toolbar-border-inside',
    text: 'Viền trong',
    option: i18nEnum.BorderOptions.Inside,
  },
  {
    icon: 'ic-excel toolbar-border-outline',
    text: 'Viền ngoài',
    option: i18nEnum.BorderOptions.Outline,
    seperatorBottom: true,
  },
  {
    icon: 'ic-excel toolbar-border-left',
    text: 'Viền trái',
    option: i18nEnum.BorderOptions.Left,
  },
  {
    icon: 'ic-excel toolbar-border-right',
    text: 'Viền phải',
    option: i18nEnum.BorderOptions.Right,
  },
  {
    icon: 'ic-excel toolbar-border-top',
    text: 'Viền trên',
    option: i18nEnum.BorderOptions.Top,
  },
  {
    icon: 'ic-excel toolbar-border-bottom',
    text: 'Viền dưới',
    option: i18nEnum.BorderOptions.Bottom,
  },
];
/**
 *
 */
export const workbookHelper = {

  /**
   * Custome các action cho con textmenu của excel
   * tvtam 19.02.2024
   */

  ContextMenuExcelOption: [
    {
      id: i18nEnum.idCommandContextMenu.CopyCustom,
      title: 'Sao chép',
      name: 'gc.spread.copy',
      command: 'copyCustom',
      iconClass: 'gc-spread-copy',
      workArea: 'viewport',
    },
    {
      id: i18nEnum.idCommandContextMenu.CutCustom,
      title: 'Cắt',
      name: 'gc.spread.cut',
      command: 'cutCustom',
      iconClass: 'gc-spread-cut',
      workArea: 'viewport',
    },
    {
      id: i18nEnum.idCommandContextMenu.PasteCustom,
      title: 'Dán',
      name: 'gc.spread.pasteValues',
      command: 'pasteCustom',
      iconClass: 'gc-spread-pasteValues',
      workArea: 'viewport',
    },
    {
      id: i18nEnum.idCommandContextMenu.AddCellDetail,
      title: 'Thêm dòng chi tiết',
      name: 'gc.spread.ShiftCellsDown',
      command: 'shiftCellsDown',
      //name: 'gc.spread.insertCell',
      // subMenu: [
      //   {
      //     text: 'Thêm bên phải',
      //     name: 'gc.spread.ShiftCellsRight',
      //     command: 'shiftCellsRight',
      //     workArea: 'viewport',
      //   },
      //   {
      //     text: 'Thêm dòng chi tiết',
      //     name: 'gc.spread.ShiftCellsDown',
      //     command: 'shiftCellsDown',
      //     workArea: 'viewport',
      //   },
      // ],
      type: i18nEnum.TypeContextMenuWorkbook.SetupPrintCol,
      workArea: 'viewport',
    },
    {
      id: i18nEnum.idCommandContextMenu.AddCellType,
      title: 'Kiểu của ô',
      name: 'gc.spread.cellType',
      workArea: 'viewport',
      subMenu: [
        {
          text: 'Kiểu nhập giá trị',
          name: 'gc.spread.text',
          command: 'insertCellTypeText',
          workArea: 'viewport',
        },
        {
          text: 'Kiểu tổng hợp',
          name: 'gc.spread.combobox',
          command: 'insertCellTypeCombobox',
          workArea: 'viewport',
        },
      ],
      type: i18nEnum.TypeContextMenuWorkbook.SetupPrint,
    },

    {
      id: i18nEnum.idCommandContextMenu.InsertRowCustom,
      title: 'Thêm dòng',
      name: 'gc.spread.insertRows',
      command: 'addRowCustom',
      workArea: 'rowHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.InsertRow,
      title: 'Thêm dòng',
      name: 'gc.spread.insertRows',
      command: 'gc.spread.contextMenu.insertRows',
      workArea: 'rowHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.InsertColumnCustom,
      title: 'Thêm cột',
      name: 'gc.spread.insertColumns',
      command: 'insertColumnsCustom',
      workArea: 'colHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.InsertColumnDetail,
      title: 'Thêm cột nhiệm vụ chi tiết',
      name: 'gc.spread.InsertColumnDetail',
      command: 'InsertColumnDetailMission',
      workArea: 'colHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.InsertColumn,
      title: 'Thêm cột',
      name: 'gc.spread.insertColumns',
      command: 'gc.spread.contextMenu.insertColumns',
      workArea: 'colHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.DeleteRow,
      title: 'Xóa dòng',
      name: 'gc.spread.deleteRows',
      command: 'deleteRowCustom',
      workArea: 'rowHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.DeleteColumn,
      title: 'Xóa cột',
      name: 'gc.spread.deleteColumns',
      command: 'gc.spread.contextMenu.deleteColumns',
      workArea: 'colHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.HideRow,
      title: 'Ẩn dòng',
      name: 'gc.spread.hideRowsCustom',
      command: 'gc.spread.contextMenu.hideRows',
      workArea: 'rowHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.UnHideRow,
      title: 'Hiện dòng',
      name: 'gc.spread.unhideRowsCustom',
      command: 'gc.spread.contextMenu.unhideRows',
      workArea: 'rowHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.AddColumnTable,
      title: 'Thêm bảng dữ liệu',
      name: 'insertRowsDetail',
      command: 'insertRowsDetail',
      workArea: 'rowHeader',
      type: i18nEnum.TypeContextMenuWorkbook.SetupPrintRow,
    },
    {
      id: i18nEnum.idCommandContextMenu.HideColumn,
      title: 'Ẩn cột',
      name: 'gc.spread.hideColumnsCustom',
      command: 'gc.spread.contextMenu.hideColumns',
      workArea: 'colHeader',
    },
    {
      id: i18nEnum.idCommandContextMenu.UnhideColumn,
      title: 'Hiện cột',
      name: 'gc.spread.unhideColumnsCustom',
      command: 'gc.spread.contextMenu.unhideColumns',
      workArea: 'colHeader',
    },
  ],

  /**
   * Custome các action cho con bảng dữ liệu
   */
  contextMenuCustomExp: [
    {
      id: i18nEnum.idCommandContextMenu.showRowsTableCondition,
      text: 'Xem bảng điều kiện ngầm định',
      name: 'showRowsTableCondition',
      command: 'showRowsTableCondition',
      workArea: 'colHeader',
    },
  ],

  /**
   * Custome các action cho con bảng dữ liệu
   */
  contextMenuExtensions: [
    {
      id: i18nEnum.idCommandContextMenu.CutRow,
      title: "Cắt",
      name: "CutRow",
      command: "gc.spread.contextMenu.cut",
      iconClass: "gc-spread-cut",
      workArea: "rowHeader"
    },
    {
      id: i18nEnum.idCommandContextMenu.InsertCutRow,
      title: "Chèn các ô cắt",
      name: "gc.spread.rowHeaderinsertCutCells",
      command: "gc.spread.contextMenu.rowHeaderinsertCutCells",
      workArea: "rowHeader"
    },
    {
      id: i18nEnum.idCommandContextMenu.Filter,
      title: "Lọc",
      name: "gc.spread.filter",
      command: "gc.spread.contextMenu.filter",
      workArea: "viewportcorner"
    },
  ],
  /**
   * Dữ liệu Toolbar
   */
  ToolbarWorkbook: [
    {
      code: 'undo',
      icon: 'ic-excel undo',
      nameCommmand: i18nEnum.actionToolbar.Undo,
      toolTip: 'Hoàn tác',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      code: 'redo',
      icon: 'ic-excel redo',
      nameCommmand: i18nEnum.actionToolbar.Redo,
      toolTip: 'Làm Lại',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      seperator: true,
    },
    {
      code: 'bold',
      icon: 'ic-excel bold',
      nameCommmand: i18nEnum.actionToolbar.Bold,
      toolTip: 'In đậm',
      type: i18nEnum.ToolbarItemType.Button,
      styleName: 'bold',
      styleValue: true,
    },
    {
      code: 'italic',
      icon: 'ic-excel italic',
      nameCommmand: i18nEnum.actionToolbar.Italicized,
      toolTip: 'In nghiêng',
      type: i18nEnum.ToolbarItemType.Button,
      styleName: 'italic',
      styleValue: true,
    },
    {
      code: 'underline',
      icon: 'ic-excel underline',
      nameCommmand: i18nEnum.actionToolbar.Underlined,
      toolTip: 'Gạch chân',
      type: i18nEnum.ToolbarItemType.Button,
      styleName: 'textDecoration',
      styleValue: GC.Spread.Sheets.TextDecorationType.underline,
    },
    {
      code: 'fontFamily',
      nameCommmand: i18nEnum.actionToolbar.FontFamily,
      toolTip: 'Font chữ',
      type: i18nEnum.ToolbarItemType.Combobox,
      comboboxValues: FontFamilies,
      styleName: 'fontFamily',
      width: 160,
    },
    {
      code: 'fontSize',
      nameCommmand: i18nEnum.actionToolbar.FontSize,
      toolTip: 'Cỡ chữ',
      type: i18nEnum.ToolbarItemType.Combobox,
      comboboxValues: FontSizes,
      styleName: 'fontSize',
      width: 64,
    },
    {
      code: 'foreColor',
      icon: 'ic-excel fore-color',
      nameCommmand: i18nEnum.actionToolbar.FontColor,
      toolTip: 'Màu chữ',
      type: i18nEnum.ToolbarItemType.ColorPicker,
      styleName: 'foreColor',
    },
    {
      code: 'backgroundColor',
      icon: 'ic-excel background-color',
      nameCommmand: i18nEnum.actionToolbar.BackgroundColor,
      toolTip: 'Màu nền',
      type: i18nEnum.ToolbarItemType.ColorPicker,
      styleName: 'foreColor',
    },
    {
      seperator: true,
    },
    {
      code: 'freeze',
      icon: 'ic-excel freeze',
      nameCommmand: i18nEnum.actionToolbar.Freeze,
      toolTip: 'Cố định dòng cột',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      code: 'unFreeze',
      icon: 'ic-excel un-freeze',
      nameCommmand: i18nEnum.actionToolbar.UnFreeze,
      toolTip: 'Bỏ cố định dòng cột',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      code: 'wordWrap',
      icon: 'ic-excel word-wrap',
      nameCommmand: i18nEnum.actionToolbar.WordWrap,
      toolTip: 'Tự động xuống dòng',
      type: i18nEnum.ToolbarItemType.Button,
      styleName: 'wordWrap',
      styleValue: true,
    },
    {
      code: 'indent',
      icon: 'ic-excel indent',
      nameCommmand: i18nEnum.actionToolbar.Indent,
      toolTip: 'Thụt lề',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      code: 'unIndent',
      icon: 'ic-excel un-indent',
      nameCommmand: i18nEnum.actionToolbar.UnIndent,
      toolTip: 'Hủy thụt lề',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      seperator: true,
    },
    {
      code: 'merger',
      icon: 'ic-excel merger',
      nameCommmand: i18nEnum.actionToolbar.MergeCell,
      toolTip: 'Hợp nhất ô',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      seperator: true,

    },
    {
      code: 'alignmentHorizontal',
      icon: 'ic-excel distributed-align',
      toolTip: 'Căn lề theo chiều ngang',
      type: i18nEnum.ToolbarItemType.Group,
      subItems: [
        {
          code: 'left-align',
          icon: 'ic-excel left-align',
          nameCommmand: i18nEnum.actionToolbar.LeftAlign,
          toolTip: 'Căn trái',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'hAlign',
          styleValue: GC.Spread.Sheets.HorizontalAlign.left,
        },
        {
          code: 'center-align',
          icon: 'ic-excel center-align',
          nameCommmand: i18nEnum.actionToolbar.CenterAlign,
          toolTip: 'Căn giữa',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'hAlign',
          styleValue: GC.Spread.Sheets.HorizontalAlign.center,
        },
        {
          code: 'right-align',
          icon: 'ic-excel right-align',
          nameCommmand: i18nEnum.actionToolbar.RightAlign,
          toolTip: 'Căn Phải',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'hAlign',
          styleValue: GC.Spread.Sheets.HorizontalAlign.right,
        },
        {
          code: 'distributed-align',
          icon: 'ic-excel distributed-align',
          nameCommmand: i18nEnum.actionToolbar.DistributedAlign,
          toolTip: 'Căn đều hai bên',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'hAlign',
          styleValue: GC.Spread.Sheets.HorizontalAlign.distributed,
        },

      ]
    },
    {
      seperator: true,
    },
    {
      code: 'alignmentVertical',
      icon: 'ic-excel mid-align',
      nameCommmand: i18nEnum.actionToolbar.TopAlign,
      toolTip: 'Căn lề theo chiều dọc',
      type: i18nEnum.ToolbarItemType.Group,
      subItems: [
        {
          code: 'top-align',
          icon: 'ic-excel top-align',
          nameCommmand: i18nEnum.actionToolbar.TopAlign,
          toolTip: 'Đầu trang',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'vAlign',
          styleValue: GC.Spread.Sheets.VerticalAlign.top,
        },
        {
          code: 'mid-align',
          icon: 'ic-excel mid-align',
          nameCommmand: i18nEnum.actionToolbar.MidAlign,
          toolTip: 'Giữa',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'vAlign',
          styleValue: GC.Spread.Sheets.VerticalAlign.center,
        },
        {
          code: 'bottom-align',
          icon: 'ic-excel bottom-align',
          nameCommmand: i18nEnum.actionToolbar.BottomAlign,
          toolTip: 'Dưới cùng',
          type: i18nEnum.ToolbarItemType.Button,
          styleName: 'vAlign',
          styleValue: GC.Spread.Sheets.VerticalAlign.bottom,
        },
      ]
    },
    {
      seperator: true,
    },
    {
      code: 'formatter',
      nameCommmand: i18nEnum.actionToolbar.Formatter,
      toolTip: 'Định dạng',
      type: i18nEnum.ToolbarItemType.Combobox,
      comboboxValues: FormatCell,
      styleName: 'formatter',
      width: 120,
    },
    {
      seperator: true,
    },
    {
      code: 'border',
      icon: 'ic-excel border',
      rightIcon: 'ic-excel drop-down',
      nameCommmand: i18nEnum.actionToolbar.BorderOptions,
      toolTip: 'Đường viền',
      type: i18nEnum.ToolbarItemType.ButtonDropdown,
      menuItems: menuItemsBorder,
    },

    {
      seperator: true,
    },
    {
      code: 'increase-decimal',
      icon: 'ic-excel increase-decimal',
      nameCommmand: i18nEnum.actionToolbar.IncreaseDecimal,
      toolTip: 'Tăng số chữ số thập phân',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      code: 'decrease-decimal',
      icon: 'ic-excel decrease-decimal',
      nameCommmand: i18nEnum.actionToolbar.DecreaseDecimal,
      toolTip: 'Giảm số chữ số thập phân',
      type: i18nEnum.ToolbarItemType.Button,
    },
    {
      seperator: true,
    },
    {
      code: 'search',
      icon: 'ic-excel search-excel',
      nameCommmand: i18nEnum.actionToolbar.Search,
      toolTip: 'Tìm kiếm',
      type: i18nEnum.ToolbarItemType.Button,
    },
  ],

  /**
   * Hàm lấy style của một range
   * Dùng để bind lên toolbar
   * TMNghia 30/03/2024
   * @param {*} range
   * @returns
   */
  getRangeStyle(range) {
    let me = this;

    let bold = range.fontWeight()?.includes('bold'),
      italic = range.fontStyle()?.includes('italic'),
      fontSize = me.getFontSize(range.fontSize());

    return {
      hAlign: range.hAlign(),
      vAlign: range.vAlign(),
      foreColor: range.foreColor(),
      wordWrap: range.wordWrap(),
      fontSize: fontSize,
      bold: bold,
      italic: italic,
      textDecoration: range.textDecoration(),
      formatter: range.formatter(),
      fontFamily: range.fontFamily().replaceAll("'", ''),
    };
  },
  /**
   * Hàm bind style lên workbook
   * TMNghia 30/03/2024
   * @param {*} workbook
   * @param {*} style
   */
  getActiveRangeStyle(workbook) {
    let me = this,
      activeSheet = workbook.getActiveSheet(),
      activeSelect = activeSheet.getSelections()[0];

    let activeRange = activeSheet.getRange(
      activeSelect.row,
      activeSelect.col,
      activeSelect.rowCount,
      activeSelect.columnCount,
    );

    return me.getRangeStyle(activeRange);
  },
  /**
   * Hàm xử lý lấy fontSize, đưa về pt
   * TMNghia 03/04/2024
   * @param {*} fontSizeString
   * @returns
   */
  getFontSize(fontSizeString) {
    if (fontSizeString?.includes('pt')) {
      return parseInt(fontSizeString.replace('pt', ''));
    } else if (fontSizeString?.includes('px')) {
      let px = fontSizeString.replace('px', '');
      return Math.round(this.pxToPt(px));
    }

    return i18nEnum.WorkbookEnum.DefaultFontSize;
  },
  /**
   * Chuyển đổi px sang pt
   * @param {*} px
   * @returns
   */
  pxToPt(px) {
    return px * 0.75;
  },

  /**
   * Render workbook từ json
   * @param {*} wb
   * @param {*} data
   * @returns
   */
  async workbookFromJson(wb, data) {
    let me = this;
    if (wb == null) {
      return;
    }

    if (!data) {
      data = {};
    }

    wb.suspendPaint();
    wb.suspendEvent();

    await wb.fromJSON(data, {
      doNotRecalculateAfterLoad: true,
    });

    wb.resumeEvent();
    wb.resumePaint();
  },

  /**
   * Render worksheet từ json
   * @param {*} ws
   * @param {*} data
   */
  async worksheetFromJson(ws, data) {
    let me = this;
    if (ws == null) {
      ws = new GC.Spread.Sheets.Worksheet('Sheet');
    }

    if (!data) {
      data = { name: 'Sheet1' };
    }

    ws.clear(
      0,
      0,
      ws.getRowCount(),
      ws.getColumnCount(),
      GC.Spread.Sheets.SheetArea.viewport,
      GC.Spread.Sheets.StorageType.data,
    );

    await ws.fromJSON(data, {
      doNotRecalculateAfterLoad: true,
    });
  },
  isNumber(str) {
    return !isNaN(Number(str)) && str.trim() !== '';
  },

  /**
   * Chèn ô
   */
  insertCells(wb, command) {
    if (!wb || !command) {
      return;
    }

    let sheet = wb.getActiveSheet(),
      sel = sheet.getSelections()[0];
    switch (command) {
      case i18nEnum.InsertOptions.ShiftCellsRight:
        sheet.moveTo(
          sel.row,
          sel.col,
          sel.row,
          sel.col + sel.colCount,
          sel.rowCount,
          sheet.getColumnCount() - (sel.col + sel.colCount),
          GC.Spread.Sheets.CopyToOptions.all,
        );
        break;

      case i18nEnum.InsertOptions.ShiftCellsDown:
        sheet.moveTo(
          sel.row,
          sel.col,
          sel.row + sel.rowCount,
          sel.col,
          sheet.getRowCount() - (sel.row + sel.rowCount),
          sel.colCount,
          GC.Spread.Sheets.CopyToOptions.all,
        );
        break;
      case i18nEnum.InsertOptions.EntireRow:
        sheet.addRows(sel.row, 1);
        sheet.copyTo(sel.row + 1, 0, sel.row, 0, 1, sheet.getColumnCount(), GC.Spread.Sheets.CopyToOptions.formula);
        sheet.copyTo(sel.row + 1, 0, sel.row, 0, 1, sheet.getColumnCount(), GC.Spread.Sheets.CopyToOptions.style);
        break;

      case i18nEnum.InsertOptions.EntireColumn:
        sheet.addColumns(sel.col, 1);
        sheet.copyTo(0, sel.col + 1, 0, sel.col, sheet.getRowCount(), 1, GC.Spread.Sheets.CopyToOptions.formula);
        sheet.copyTo(0, sel.col + 1, 0, sel.col, sheet.getRowCount(), 1, GC.Spread.Sheets.CopyToOptions.style);
        break;
    }
  },

  /**
   * Xử lý thêm dữ liệu MLNS vào mẫu nhập liệu thuyết minh
   * @param {Workbook} wb 
   * @param {*} payload 
   * @returns 
   */
  async initWbDictionaryNames(wb, wbComponent, payload) {
    if (!wb || !payload) return;

    //Nếu đã tồn tại dữ liệu MLNS thì dừng
    if (wb.getActiveSheet().getCustomName(i18nEnum.WorkbookEnum.HasDicNames)) return;

    try {
      //Lấy dữ liệu thông tin chung
      let dicNames = await expAPI.getDictionaryNames(payload);

      if (dicNames?.length > 0) {

        wb.suspendPaint();
        wb.suspendEvent();
        wb.suspendCalcService();
        //Đánh dấu đã thêm dữ liệu thông tin chung
        dicNames.push({ FieldCode: i18nEnum.WorkbookEnum.HasDicNames, Value: true });
        //Duyệt qua từng sheet để thêm thông tin MLNS
        wb.sheets.forEach(sheet => {
          wbComponent.initWorksheetCustomName(dicNames, sheet.name());
        });
      }
    }
    catch (err) {
      console.error(err);
    }
    finally {
      wb.resumeCalcService();
      wb.resumeEvent();
      wb.resumePaint();
    }
  },

  /**
   * Hàm lấy dữ liệu của một ô trong sheet
   */
  getCellValue(sheet, row, col) {
    if (!sheet) return null;
    let span = sheet.getSpan(row, col),
      cellValue = ''; // Kiểm tra xem ô có bị merge không

    if (span) {
      // Lấy giá trị từ ô gốc của vùng merge
      cellValue = sheet.getValue(span.row, span.col);
    } else {
      // Nếu ô không bị merge, lấy giá trị bình thường
      cellValue = sheet.getValue(row, col);
    }
    if (typeof cellValue === 'string') {
      cellValue = cellValue.trim();
    }

    return cellValue;
  },

  /**
   * Đọc dữ liệu điều kiện
   * @param {*} sheet 
   * @returns 
   */
  readConditions(sheet) {
    if (!sheet) return null;
    let range = sheet.getSelections()[0],
      startRow = range.row,
      minCol = range.col,
      endRow = range.row + range.rowCount - 1,
      maxCol = range.col + range.colCount - 1,
      conditions = [];

    if (endRow == 0 || maxCol == 0) return null;

    for (let row = startRow + 1; row <= endRow; row++) {
      let rowValue = this.getCellValue(sheet, row, maxCol);
      if (!rowValue) continue;

      let condition = {
        DefaultValue: rowValue
      };

      for (let col = minCol; col < maxCol; col++) {
        let colName = this.getCellValue(sheet, startRow, col);
        if (this.getCellValue(sheet, row, col)) {
          condition[colName] = [this.getCellValue(sheet, row, col)];
        }
      }

      conditions.push(condition);
    }

    return conditions;
  },

  /**
   * Gộp dữ liệu DefaultValue
   * @param {*} data 
   * @returns 
   */
  mergeDefaultValues(data) {
    let groupedData = new Map();

    data.forEach(item => {
      // Lấy tất cả key trừ 'DefaultValue'
      let keys = Object.keys(item).filter(k => k !== "DefaultValue");

      // Tạo key duy nhất từ tất cả Field
      let key = JSON.stringify(keys.map(k => item[k]));

      if (!groupedData.has(key)) {
        // Nếu chưa có nhóm này, tạo mới
        let itemValue = {
          ...item,
          DefaultFilter: [item.DefaultValue]
        };

        delete itemValue.DefaultValue;
        groupedData.set(key, itemValue);
      } else {
        // Nếu đã có nhóm, gộp DefaultValue vào mảng
        groupedData.get(key).DefaultFilter.push(item.DefaultValue);
      }
    });

    return Array.from(groupedData.values());
  },

  /**
   * Parse chuỗi điều kiện sang đối tượng
   * @param {*} conditionString 
   * @returns 
   */
  parseConditions(conditionString) {
    const me = this;
    const operators = ["AND", "OR"];
    const regex = new RegExp(`\\s*(${operators.join("|")})\\s*`, "i"); // Regex tách toán tử logic
    const tokens = conditionString.split(regex).map(token => token.trim()); // Tách chuỗi

    let result = [];

    for (let i = 0; i < tokens.length; i += 2) {
      let conditionObj = me.parseCondition(tokens[i]); // Phân tích điều kiện
      if (conditionObj) {
        let logical_operator = i === 0 ? null : tokens[i - 1].toUpperCase(); // Gán toán tử logic
        conditionObj.logical_operator = logical_operator === 'AND' ? 0 : (logical_operator === 'OR' ? 1 : null);
        result.push(conditionObj);
      }
    }

    return result;
  },

  /**
   * Parse điều kiện
   * @param {*} condition 
   * @returns 
   */
  parseCondition(condition) {
    const conditionRegex = /^\[(.+?)\]\s*(!=|<>|><|NOT IN|IN|>=|<=|>|<|=)\s*(.+)$/i;
    const match = condition.match(conditionRegex);

    if (!match) return null; // Không đúng định dạng

    let field_code = match[1].trim();
    let compare_function = match[2].trim().toUpperCase();
    let value = match[3].trim();

    // Xử lý giá trị
    if ((value.startsWith("'") && value.endsWith("'")) || (value.startsWith('"') && value.endsWith('"'))) {
      value = value.slice(1, -1); // Loại bỏ dấu '
    } else if (value.startsWith("[") && value.endsWith("]")) {
      value = value.slice(1, -1).split(/\s*,\s*/).map(v => v.replace(/^'|'$/g, "")); // Xử lý mảng
      value = value.join('|');
    } else if (!isNaN(value)) {
      value = Number(value); // Chuyển thành số nếu có thể
    }

    return { field_code, compare_function, value };
  },

  /**
   * Chuyển đối tượng điều kiện sang chuỗi
   */
  stringifyConditions(parsedConditions) {
    return parsedConditions
      .map((cond, index) => {
        let valueStr;
        if (!cond.value) return '';

        if (Array.isArray(cond.value)) {
          valueStr = `(${cond.value.map(v => `'${v}'`).join(", ")})`; // Chuyển mảng thành chuỗi
        }

        else if (typeof cond.value === "string" && cond.value.includes('|') && cond.compare_function === 'IN') {
          let valueArray = cond.value.split('|');
          valueStr = `[${valueArray.map(v => {
            if (typeof v === 'string') { return `'${v}'`; }
            else return v;
          }).join(", ")}]`; // Chuyển mảng thành chuỗi
        }

        else if (typeof cond.value === "string") {
          valueStr = `'${cond.value}'`; // Chuỗi bao bởi dấu '
        } else {
          valueStr = cond.value; // Số giữ nguyên
        }

        let conditionStr = `[${cond.field_code}] ${cond.compare_function} ${valueStr}`;
        let logicalText = cond.logical_operator === 0 ? 'AND' : (cond.logical_operator === 1 ? 'OR' : ''); // Toán tử logic

        return logicalText ? `${logicalText} ${conditionStr}` : conditionStr;
      })
      .join(" ");
  },

  /**
 * Hàm đọc dữ liệu từ 4 cột trong worksheet SpreadJS
 * - Cột 1: lưu mã khoản, tên thuộc tính KHOAN
 * - Cột 2: lưu thông tin mã loại, tên thuộc tính LOAI, cần tách theo dấu phẩy và lưu dạng mảng
 * - Cột 3: lưu thông tin cấp ngân sách, tên thuộc tính CT_CAPNGANSACH
 * - Cột 4: lưu thông tin mã nguồn dữ liệu, tên thuộc tính SOURCE (nếu cột này có dữ liệu thì mới sinh ra bản ghi)
 * 
 * @param {Object} sheet - SpreadJS worksheet
 * @returns {Array} Danh sách đối tượng đã đọc từ worksheet
 */
  getDataFromWorksheet(sheet) {
    if (!sheet) return [];

    // Mảng kết quả chứa dữ liệu từ các hàng
    const result = [];

    // Lấy số hàng trong sheet
    const rowCount = sheet.getRowCount();

    // Duyệt qua từng hàng 
    for (let row = 0; row < rowCount; row++) {
      // Đọc dữ liệu từ các cột
      const maLoai = workbookHelper.getCellValue(sheet, row, 0);        // LOAI (Cột 2)
      const maKhoan = workbookHelper.getCellValue(sheet, row, 1);       // KHOAN (Cột 1)
      const capNganSach = workbookHelper.getCellValue(sheet, row, 2);   // CT_CAPNGANSACH (Cột 3)
      const maNguon = workbookHelper.getCellValue(sheet, row, 3);       // SOURCE (Cột 4)

      // Kiểm tra điều kiện: chỉ thêm bản ghi khi SOURCE có dữ liệu
      if (maNguon) {
        // Xử lý đặc biệt cho maLoai: tách theo dấu phẩy và trim()
        let maKhoanArray = [];
        if (maKhoan) {
          maKhoanArray = maKhoan.split(',').map(item => item.trim());
        }

        // Tạo đối tượng chứa thông tin từ hàng hiện tại
        const record = {
          KHOAN: maKhoanArray,
          LOAI: maLoai,
          CT_CAPNGANSACH: capNganSach,
          SOURCE: maNguon,
          rowIndex: row // Thêm rowIndex để biết dòng nào trong worksheet
        };

        // Thêm vào mảng kết quả
        result.push(record);
      }
    }

    return result;
  },

  /**
 * Hàm chuyển đổi dữ liệu từ worksheet sang định dạng yêu cầu
 * @param {Object} sheet - SpreadJS worksheet
 * @param {Array} explanationFormList - Danh sách thuyết minh form để lookup dựa vào SOURCE
 * @returns {Array} Danh sách đối tượng đã chuyển đổi theo yêu cầu
 */
  convertWorksheetToDataFormat(sheet, explanationFormList = []) {
    if (!sheet) return [];

    // Bước 1: Đọc dữ liệu từ worksheet
    const rawData = this.getDataFromWorksheet(sheet);

    // Bước 2: Chuyển đổi dữ liệu theo định dạng yêu cầu
    const result = rawData.map(item => {
      // Sinh GUID mới cho mỗi bản ghi
      const id = commonFunction.generateUUID();

      // Tìm thông tin từ explanationFormList dựa vào SOURCE
      const sourceInfo = explanationFormList.filter(form => item.SOURCE.includes(form.explanation_form_code));
      if (!sourceInfo || sourceInfo.length == 0) return;

      // Khởi tạo mảng conditions rỗng
      const conditions = [];

      // Thêm điều kiện LOAI nếu có dữ liệu
      if (item.LOAI && item.LOAI.length > 0) {
        conditions.push({
          field_code: "LOAI",
          field_name: "Loại",
          compare_function: "=",
          value: item.LOAI, // Lấy giá trị đầu tiên làm điều kiện
          data_type: 35
        });
      }

      // Thêm điều kiện KHOAN nếu có dữ liệu
      if (item.KHOAN && item.KHOAN.length > 0) {
        conditions.push({
          field_code: "KHOAN",
          field_name: "Khoản",
          compare_function: "IN",
          value: Array.isArray(item.KHOAN) ? item.KHOAN.join('|') : item.KHOAN,
          data_type: 35,
          fieldCompareSeleted: []
        });
      }

      // Thêm điều kiện CT_CAPNGANSACH nếu có dữ liệu
      if (item.CT_CAPNGANSACH) {
        conditions.push({
          field_code: "CT_CAPNGANSACH",
          field_name: "Cấp ngân sách",
          compare_function: "=",
          value: item.CT_CAPNGANSACH,
          data_type: 35
        });
      }

      // Tạo đối tượng kết quả theo cấu trúc yêu cầu
      return {
        id: id,
        areaName: `Dongdulieu${item.rowIndex + 1}`,
        dataType: sourceInfo.find(t => t)?.type,
        type: 0, // Mặc định 0
        tables: sourceInfo.find(t => t)?.type == 10 ? '[THUYETMINH]' : '[THUYETMINHLUONG]',
        dataRow: {
          report_custom_area_id: id, // Lấy từ thuộc tính id của metadata
          report_custom_area_name: `Dòng dữ liệu ${item.rowIndex + 1}`, // Tạo tên từ rowIndex
          category_data_source: sourceInfo.find(t => t)?.type,
          explanation_form: sourceInfo.map(item => {
            return {
              type: item.type,
              explanation_form_id: item.explanation_form_id,
              explanation_form_code: item.explanation_form_code,
              explanation_form_name: item.explanation_form_name,
              selected: false
            }
          }),
          explanation_form_name: sourceInfo.map(item => item.explanation_form_code).join('|'), // Tạo tên từ danh sách
          row_type: 0, // Mặc định 0
          conditions: [...conditions] // Sử dụng mảng conditions đã được lọc
        },
        sources: sourceInfo.map(item => {
          return {
              type: sourceInfo.find(t => t)?.type,
            explanation_form_id: item.explanation_form_id,
            explanation_form_code: item.explanation_form_code,
            explanation_form_name: item.explanation_form_name,
            selected: false
          }
        }),
        conditions: [...conditions], // Sử dụng lại mảng conditions đã được lọc
        rowIndex: item.rowIndex
      };
    });

    return result;
  },

  /**
 * Tự động cập nhật giá trị cho các ô trong phạm vi được chỉ định
 * @param {Object} sheet - Sheet cần cập nhật
 * @param {Object} range - Phạm vi cần cập nhật (có dạng {row, col, rowCount, colCount})
 * @param {Number} sourceCol - Chỉ số của cột lưu giá trị nguồn dữ liệu
 */
  autoUpdateCellValues(sheet, range, sourceCol) {
    // Kiểm tra các tham số đầu vào
    if (!sheet || !range || sourceCol === undefined) return;

    sheet.suspendPaint();
    sheet.suspendEvent();
    // Duyệt qua từng ô trong phạm vi
    for (let row = range.row; row < range.row + range.rowCount; row++) {
      for (let col = range.col; col < range.col + range.colCount; col++) {
        // Bỏ qua cột nguồn
        if (col === sourceCol) continue;

        // Lấy giá trị ô hiện tại
        let cellValue = this.getCellValue(sheet, row, col);

        sheet.getCell(row, col).backColor(null);

        // Kiểm tra nếu ô rỗng thì bỏ qua
        if (!cellValue || cellValue === "") continue;

        // Kiểm tra giá trị ô có phải trường dữ liệu (không chứa ký tự đặc biệt)
        if (this.isDataField(cellValue)) {
          // Lấy giá trị ô nguồn dữ liệu
          let sourceValue = this.getCellValue(sheet, row, sourceCol);

          // Chuẩn hóa và kiểm tra nguồn dữ liệu
          let sources = this.getSources(sourceValue);

          // Nếu chỉ có một nguồn dữ liệu, cập nhật cú pháp
          if (sources.length === 1) {
            // Cập nhật cú pháp mới: OT=[SUM[cellValue]]
            let newValue = `OT=[SUM[${cellValue}]]`;
            sheet.setValue(row, col, newValue);
          }
        }
      }
    }

    sheet.resumeEvent();
    sheet.resumePaint();
  },

  /**
   * Kiểm tra một chuỗi có phải là trường dữ liệu hợp lệ không
   * @param {String} value - Chuỗi cần kiểm tra
   * @returns {Boolean} - true nếu không chứa ký tự đặc biệt
   */
  isDataField(value) {
    // Kiểm tra không chứa các ký tự đặc biệt
    return /^[\p{L}\p{N}_]+$/u.test(value);
  },

  /**
   * Trích xuất các nguồn dữ liệu từ một chuỗi
   * @param {String} value - Chuỗi cần xử lý
   * @returns {Array} - Mảng các nguồn dữ liệu
   */
  getSources(value) {
    if (!value) return [];

    // Xóa chuỗi ', ' ở đầu và cuối
    value = value.trim().replace(/^, |, $/g, '');

    // Tách theo ', ' để lấy các nguồn dữ liệu
    return value ? value.split(', ') : [];
  },


};
